import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard, NoAuthGuard } from '@libs/core/auth';
import { LoginPage } from './login/login.page';
import { hasAcceptedPrivacyPolicy } from '@libs/core/privacy-policy';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    canActivate: [AuthGuard, hasAcceptedPrivacyPolicy],
  },
  {
    path: 'login',
    component: LoginPage,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'emergency',
    loadChildren: () => import('./emergency/emergency.module').then((m) => m.EmergencyModule),
    canActivate: [AuthGuard, hasAcceptedPrivacyPolicy],
  },
  {
    path: 'report-wizard',
    loadChildren: () => import('./report-wizard/report-wizard.module').then((m) => m.ReportWizardModule),
    canActivate: [AuthGuard, hasAcceptedPrivacyPolicy],
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule),
    canActivate: [AuthGuard, hasAcceptedPrivacyPolicy],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
